/* eslint no-use-before-define: 0 */  // --> OFF
<template>

    <v-autocomplete
        :loading="loading"
        :search-input.sync="searchPlace"
        dense
        hide-details="auto"
        @click:clear="clear"
        @click:prepend-inner="geolocate"
        prepend-inner-icon="mdi-crosshairs-gps"
        :items="placesList"
        label="Select Location*"
        v-model="selectedPlace"
        color="#9f9f9f"
        name="place"
        item-text="name"
        autocomplete="new-password"
        return-object
        outlined        
        clearable
        :multiple="false"        
        class="place_autocomplete"
    >
        <template v-slot:no-data>
            <v-list-item v-if="loading">
                <v-list-item-title>                    
                    <span >Loading...</span>                    
                </v-list-item-title>
            </v-list-item>
        </template>
    </v-autocomplete>
</template>

<script>

    export default {
        name: "PlaceAutocomplete",
        props: ['place_types','place_filter','place_name'],
        watch: {         
          selectedPlace:function(val){                        
            if(val){
              this.getPlaceDetails(val)
            }
            else{
              this.$emit('place_changed', null)
            }
          },
          searchPlace: {
                handler(val) {
                    clearTimeout(this._timerId)
                    this._timerId = setTimeout(() => { 
                        if(val.length > 3){
                            console.log("CALLED" + val)
                            if(this.isPopulating){
                                this.isPopulating = false
                                return
                            }
                            
                            if(val) {
                                this.getPlaces()
                            }                 
                            else{
                                this.placesList = []
                            }               
                        }
                        else{
                            this.placesList = []
                        }                                                        
                    },400)
                
                }
            },   
        },
       
        methods: {  
          geolocate(){
                
                navigator.geolocation.getCurrentPosition(position => {
                    var currentLatLng = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }                    
                    this.updateCoordinates(currentLatLng)
                    
                },this.geoLocateError)
          },
          geoLocationSuccess(position){
                var currentLatLng = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                }                    
                
                this.updateCoordinates(currentLatLng)
            },
            geoLocateError(error) {
                
                switch(error.code) {
                    case error.PERMISSION_DENIED:
                        try{
                            navigator.permissions.query({name:'geolocation'}).then(function(result) {                                
                                if (result.state == 'granted') {
                                    navigator.geolocation.getCurrentPosition(this.geoLocationSuccess)
                                }
                                else if (result.state == 'denied') {
                                    alert("Location permission denied.")
                                }
                            });
                        }
                        catch(err){
                            alert("Location permission denied.")
                        }                        
                        
                    break;
                    case error.POSITION_UNAVAILABLE:
                        alert("Location information is unavailable.")
                    break;
                    case error.TIMEOUT:
                    alert("The request to get user location timed out.")
                    break;
                    case error.UNKNOWN_ERROR:
                        alert("An unknown error occurred.")
                    break;
                }
            },
          updateCoordinates (value) {

                if (!value && !(value.lat || value.lng)) return;
                if (!this.geocoder) this.geocoder = new window.google.maps.Geocoder();                
                    
                this.geocoder.geocode({ 'latLng': value }, (result, status) => {
                    if (status === window.google.maps.GeocoderStatus.OK) {                      
                      console.log(result[0])
                      var item ={
                         name:result[0].formatted_address,
                         place_id:result[0].place_id
                       };                       
                       this.isPopulating = true
                       this.placesList = [item]                       
                       this.selectedPlace = item;                       
          
                    }                                                             
                })
                                
            },
          fetchCurrentLocation(){
            this.$emit('fetchCurrentLocation');                        
          },
          clear(){
            this.$emit('locationRemoved');                        
          },
          updateField(address){
                var item ={
                    name:address                    
                };                       
                this.isPopulating = true
                this.placesList = [item]                       
                this.selectedPlace = item;  
            },
          getPlaces(){
            var url = new URL(`${process.env.VUE_APP_API_URL}/api/places/autocomplete`)            
            url.searchParams.append("input", this.searchPlace)
            url.searchParams.append("types", this.types)            

            this.axios.get(url.href)
                    .then((response) => {

                        var data = response.data.predictions
                        var dataList = []
                        data.forEach(element => {
                          
                          var proceed = true
                          if(this.filteredTypes.length)
                            proceed = element.types.some(r=> this.filteredTypes.includes(r))
                          if(proceed){
                            var item = {
                              name:element.description,
                              place_id:element.place_id
                            }                            
                            dataList.push(item);
                          }
                          
                        });
                        
                        this.placesList = dataList                        
                    })
          },
          getPlaceDetails(selectedPlace){
            this.$emit('placeLoading');
            var url = new URL(`${process.env.VUE_APP_API_URL}/api/places/details`)            
            url.searchParams.append("place_id", this.selectedPlace.place_id)            
                

            this.axios.get(url.href)
                    .then((response) => {
                        var place = response.data.result
                        place.name = selectedPlace.name
                        
                        this.$emit('placechanged', place);                        
                        this.$emit('placeLoadingDone');
                    })
          },
          getAddressComponents(place) {
                
                let premise = place.address_components.find(addressComponent => addressComponent.types.includes('premise'))
                let route = place.address_components.find(addressComponent => addressComponent.types.includes('route'))
                let sublocality = place.address_components.find(addressComponent => addressComponent.types.includes('sublocality'))
                let postal_code = place.address_components.find(addressComponent => addressComponent.types.includes('postal_code'))
                let city = place.address_components.find(addressComponent => addressComponent.types.includes('locality'))
                let state = place.address_components.find(addressComponent => addressComponent.types.includes('administrative_area_level_1'))
                let country = place.address_components.find(addressComponent => addressComponent.types.includes('country'))
                let address = place.formatted_address
                
                
                let returnObject = {
                    premise: premise ? premise.long_name : null,
                    route: route ? route.long_name : null,
                    sublocality: sublocality ? sublocality.long_name : null,

                    postal_code: postal_code ? postal_code.long_name : null,
                    city: city ? city.long_name : null,
                    state: state ? state.long_name : null,
                    country: country ? country.long_name : null,
                    address: address ? address : null,
                    latitude: place.geometry.location.lat,
                    longitude: place.geometry.location.lng,
                }

                var new_address = "";
                if(!this.isStrEmpty(place.name)){
                    new_address = place.name
                }
                else{
                    var address_arr = []
                    if(!this.isStrEmpty(returnObject.premise))
                        address_arr.push(returnObject.premise)
                    if(!this.isStrEmpty(returnObject.route))
                        address_arr.push(returnObject.route)
                    if(!this.isStrEmpty(returnObject.sublocality))
                        address_arr.push(returnObject.sublocality)
                    
                    if(address_arr.length)
                        new_address = address_arr.join(",")
                    else
                        new_address = returnObject.address                    
                }
                returnObject.local_address = new_address
                
                return returnObject
            }                         
        },
        data() {
            return {                
                saveLoading: false,
                fetchPlacesTimer: false,                
                searchPlace:'',
                loading: false,
                selectedPlace:{},                
                placesList: [],
                filteredTypes:['sublocality', 'locality'],
                types:'(regions)',
                geocoder:null,
                isPopulating:false
            }
        },
        mounted() {
          
          if(this.place_name)
            this.updateField(this.place_name)
           if(this.place_types)
              this.types = this.place_types            

            if(this.place_filter)
              this.filteredTypes = this.place_filter

        }
    }
</script>
<style scoped>

.place_autocomplete>.v-input__control>.v-input__slot {
    border: 1px solid #D3D3D3 !important;
    margin-bottom:0px;
}

.place_autocomplete>.v-input__control>.v-text-field__details {
    margin-bottom:0px;
}


</style>